/**
 * ObjectSelectField React component
 * 
 * @author    Maurizio Tidei, Jens Gruschel
 * @copyright © 2019 contexagon GmbH
 */


// React
import React from 'react';
import PropTypes from 'prop-types';
import connect from "react-redux/es/connect/connect";

// Material UI components
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';

// application
import {selectTranslation} from "../../redux/configuration/selectors";


/**
 * ObjectSelectField is an editing component for option select fields of objects
 *
 * @author Maurizio Tidei, Jens Gruschel
 */
export class ObjectSelectField extends React.Component {

    handleChange(event) {
        const value = event.target.value === "" ? undefined : event.target.value;
        this.props.onObjectValueChange(this.props.fieldDef.id, value);
    };

    render() {

        const { fieldDef } = this.props;

        const options = fieldDef.options || [];
        const translations = fieldDef.translations || {}

        return <FormControl fullWidth={true} margin="normal">
            <InputLabel>{fieldDef.name}</InputLabel>
            <Select
                value={this.props.value == null ? "" : this.props.value}
                disabled={this.props.readOnly}
                onChange={event => this.handleChange(event)}
            >
                {options.map(option => {
                    const value = option == null ? "" : option;
                    const translation = translations[option];
                    const text = translation ? this.props.translate(translation) : option;
                    return <MenuItem key={value} value={value}>{text}</MenuItem>;
                })}
            </Select>
        </FormControl>;
    }
}

ObjectSelectField.propTypes = {
    onObjectValueChange: PropTypes.func.isRequired,
    fieldDef: PropTypes.object.isRequired,
    objectId: PropTypes.string,
    readOnly: PropTypes.bool,
    value: PropTypes.any
};

const mapStateToProps = (state) => {
    return {
        translate: (value) => selectTranslation(state.configuration, value)
    };
};

export default connect(mapStateToProps)(ObjectSelectField);